import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { ReactComponent as LogoIcon } from '../../assets/images/logo.svg';
import { Wrapper, StyledLinkItem, Icon, WrapperLinks } from './styled';

import { serviceRoles } from '../../utils/serviceRoles';
import { setUsersPermissions } from '../../utils/setUsersPermissions';

export const Sidebar = () => {
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);
  const { userData: userInfo } = useSelector((state) => state.currentUser);

  return (
    <Wrapper data-testid="Sidebar">
      <Box mb={3} sx={{ textAlign: 'center' }}>
        <LogoIcon data-testid="LogoIcon" />
      </Box>

      <WrapperLinks data-testid="WrapperLinks">
        {userInfo &&
          Object.keys(userInfo).length !== 0 &&
          serviceRoles(userInfo.role.id, permissions).groupLink.map(({ id, label, to, icon }) => (
            <StyledLinkItem key={id} to={to}>
              <Icon as={icon} />
              <Typography
                variant="body"
                component="span"
                sx={{ fontWeight: 500, color: 'text.secondary', lineHeight: '24px' }}>
                {label}
              </Typography>
            </StyledLinkItem>
          ))}
      </WrapperLinks>
    </Wrapper>
  );
};
